module.exports = "<div data-bind=\"text: counter.remainingCharacterCounter, css: remainingCharacterCounter\"></div>";